import { integrationBuildError } from './integrationBuildRequest'

const messages = {
  AD_INVALID_REQUEST: '交付包请求或发布条件已变化，请核实原记录',
  AD_APP_NOT_AVAILABLE: '应用不存在，或尚未审核通过并发布',
  AD_NOT_READY: '加密包尚未就绪，请稍后刷新或联系管理员',
  AD_SIZE_LIMIT: '交付内容或存储超过限制，请联系管理员',
  AD_STATE_INVALID: '公开信息与算法包的关联检查未通过，请联系管理员',
  AD_OBJECT_UNAVAILABLE: '交付原件暂不可读，请保留原记录并联系管理员',
  AD_INTERNAL_ERROR: '交付操作结果尚未确认，请核实原记录',
  RP_INVALID_REQUEST: '请求信息或发布条件已变化，请核实原记录后再操作',
  RP_APP_NOT_AVAILABLE: '应用不存在，或尚未审核通过并发布',
  RP_NOT_READY: '加密导出尚未就绪，请检查运行条件并核实原申请',
  RP_SIZE_LIMIT: '内容或存储容量超出限制，请联系管理员处理',
  RP_STATE_INVALID: '加密包检查未通过，请联系管理员核实',
  RP_OBJECT_UNAVAILABLE: '加密包暂不可读，请保留原记录并联系管理员',
  RP_INTERNAL_ERROR: '操作结果暂未确认，请核实原记录',
  RP_UNAUTHORIZED: '登录身份已失效，请重新登录',
  RP_FORBIDDEN: '未分配算法制品发布权限',
  RP_RESPONSE_INVALID: '响应未能确认，请核实原记录',
  RP_STORAGE_UNAVAILABLE: '无法保存本次操作记录，已停止提交；请恢复浏览器会话存储',
  RP_JOURNAL_INVALID: '本页保存的操作记录不完整，请通过生成历史核实，不要重复申请'
}

export const isRuntimePackageRequest = config => Boolean(config && config.runtimePackageRequest)

export function runtimePackageError(body, status) {
  const code = status === 401 || (body && body.code === 401) ? 'RP_UNAUTHORIZED'
    : status === 403 || (body && body.code === 403) ? 'RP_FORBIDDEN'
      : body && body.data && body.data.errorCode
  const safeCode = Object.prototype.hasOwnProperty.call(messages, code) ? code : 'RP_RESPONSE_INVALID'
  // A failed POST or a malformed success never proves that the server rolled back.
  return { code: safeCode, message: messages[safeCode], unknown: true,
    unauthorized: safeCode === 'RP_UNAUTHORIZED', forbidden: safeCode === 'RP_FORBIDDEN' }
}

export function packageFailure(code) {
  return runtimePackageError({ data: { errorCode: code } })
}

export function operationMessage(error) {
  if (error && Object.prototype.hasOwnProperty.call(messages, error.code)) return messages[error.code]
  return integrationBuildError({ data: { code: error && error.code } }).message
}
// Match the versioned backend target contract; unknown/legacy targets retain 64 MiB.
export const packageByteLimit = targetProfileId => [
  'algorithm-runtime-development-contract-v1',
  'algorithm-runtime-development-large-capacity-v1',
  'shandobako-runtime-api34-large-capacity-v1'
].includes(targetProfileId) ? 134217728 : 67108864
export const deliveryByteLimit = targetProfileId => packageByteLimit(targetProfileId) === 134217728
  ? 152043520 : 84934656



// WEBPACK FOOTER //
// ./src/utils/runtimePackageRequest.js